import { createContext } from 'react'
import type { UserInfo } from '@/api/auth'
import type { Role } from '@/auth/roles'

/**
 * `signingOut` is its own state on purpose: during an RP-initiated logout the session is already
 * gone locally, but flipping straight to `anonymous` would make the route guard bounce to
 * /login — whose effect immediately starts a login redirect that races the logout redirect.
 */
export type AuthStatus = 'loading' | 'authenticated' | 'anonymous' | 'signingOut'

export type AuthContextValue = {
  status: AuthStatus
  user: UserInfo | null
  /** Without the `ROLE_` prefix, e.g. `["ADMIN"]`. */
  roles: string[]
  effectiveRoles: string[]
  /** Honours the hierarchy: true for an ADMIN asked about `MANAGER`. */
  hasRole: (role: Role) => boolean
  login: () => Promise<void>
  /** RP-initiated logout: ends the Keycloak session, not just the local one. */
  logout: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)
